import React, { useState, useEffect } from "react";
import { Table } from "react-bootstrap";
import {
  getEmpleados,
  deleteEmpleado,
  getEmpleadoById,
} from "../helpers/rutaEmpleados";
import ModalFormEmpleado from "./ModalFormEmpleado";
import "../css/tableclientes.css";

const TableEmpleados = () => {
  const [empleados, setEmpleados] = useState({
    data: {},
    loading: true,
  });

  const [empleado, setEmpleado] = useState({});
  const [show, setShow] = useState(false);

  useEffect(() => {
    consultaEmpleados();
  }, []);

  const consultaEmpleados = () => {
    getEmpleados().then((datos) => {
      console.log("📦 Empleados:", datos);
      setEmpleados({
        data: datos,
        loading: false,
      });
    });
  };

  const handleClose = () => {
    setShow(false);
    consultaEmpleados();
  };

  const handleShow = () => setShow(true);

  const modificaEmpleado = (id) => {
    getEmpleadoById(id).then((resp) => {
      if (resp.ok) {
        setEmpleado(resp.empleado);
        handleShow();
      } else {
        console.error("❌ Error al obtener empleado:", resp.error);
      }
    });
  };

  const eliminarEmpleado = (id) => {
    const confirmar = window.confirm("¿Está seguro que desea borrar el empleado?");
    if (confirmar) {
      deleteEmpleado(id).then(() => {
        consultaEmpleados();
      });
    }
  };

  return (
    <div className="table-container" style={{ overflowX: "auto" }}>
      {!empleados.loading && (
        <>
          <div className="col-12 mt-4" />
          <div>
            <Table
              striped
              bordered
              hover
              style={{
                minWidth: "1420px",
                tableLayout: "fixed",
              }}
            >
              <colgroup>
                <col style={{ width: "50px" }} />
                <col style={{ width: "20px" }} />
                <col style={{ width: "60px" }} />
                <col style={{ width: "60px" }} />
                <col style={{ width: "40px" }} />
                <col style={{ width: "80px" }} />
                <col style={{ width: "60px" }} />
                <col style={{ width: "60px" }} />
                <col style={{ width: "60px" }} />
                <col style={{ width: "100px" }} />
              </colgroup>

              <thead>
                <tr className="header">
                  <th className="acciones">Acciones</th>
                  <th>Nro</th>
                  <th>Apellido</th>
                  <th>Nombre</th>
                  <th>DNI</th>
                  <th>Domicilio</th>
                  <th>Teléfono</th>
                  <th>Cargo</th>
                  <th>Sueldo Actual</th>
                  <th>Observaciones</th>
                </tr>
              </thead>

              <tbody>
                {(empleados.data.empleados || []).map((empleado) =>
                  empleado.activo ? (
                    <tr key={empleado._id}>
                      <td style={{ whiteSpace: "nowrap" }}>
                        <button
                          className="btn btn-primary"
                          onClick={() => modificaEmpleado(empleado._id)}
                        >
                          <i className="fa fa-pencil-square-o" aria-hidden="true" />
                        </button>

                        <button
                          className="btn btn-danger ml-2"
                          onClick={() => eliminarEmpleado(empleado._id)}
                        >
                          <i className="fa fa-trash-o" aria-hidden="true" />
                        </button>
                      </td>

                      <td style={{ textAlign: "center" }}>{empleado.codemp}</td>
                      <td style={{ textAlign: "left" }}>{empleado.apellido}</td>
                      <td style={{ textAlign: "left" }}>{empleado.nombre}</td>
                      <td style={{ whiteSpace: "nowrap" }}>{empleado.dni}</td>
                      <td>{empleado.domicilio || "-"}</td>
                      <td style={{ whiteSpace: "nowrap" }}>{empleado.telefono || "-"}</td>
                      <td>{empleado.cargo || "-"}</td>
                      <td style={{ whiteSpace: "nowrap", textAlign: "right" }}>
                        {Number(empleado.sueldoActual || 0).toLocaleString("es-AR", {
                          style: "currency",
                          currency: "ARS",
                          minimumFractionDigits: 2,
                        })}
                      </td>
                      <td>{empleado.observaciones || "-"}</td>
                    </tr>
                  ) : null
                )}
              </tbody>
            </Table>
          </div>

          <ModalFormEmpleado
            show={show}
            handleClose={handleClose}
            empleado={empleado}
          />
        </>
      )}
    </div>
  );
};

export default TableEmpleados;